import { Component, input } from '@angular/core';
import { CwBanner } from '@bbraun/cortex-angular';
import { TranslateModule } from '@ngx-translate/core';
import { Dialog } from '~/app/services/dialog.service';

@Component({
  selector: 'gplus-edit-organization-settings-modal',
  imports: [CwBanner, TranslateModule],
  templateUrl: './edit-organization-settings-modal.component.html',
  styleUrl: './edit-organization-settings-modal.component.scss'
})
export class EditOrganizationSettingsModalComponent {
  public dialog = input<Dialog>(null);
}
